import getConfig from 'libs/get.config';
import { get } from 'lodash';
import { isSMBPortal } from 'utils/applicationHelper';

export const getSMBChangePasswordUrl = (): string =>
  getConfig({
    configName: 'smbPortal.CHANGE_PASSWORD_URL',
    defaultValue: 'https://www.spectrumbusiness.net/user-preferences/sign-in-security',
  });
export const getSMBSupportUrl = (): string =>
  getConfig({
    configName: 'smbPortal.SUPPORT_URL',
    defaultValue: 'https://www.spectrumbusiness.net/support',
  });
export const getSMBAccountSummaryUrl = (): string =>
  getConfig({
    configName: 'smbPortal.ACCOUNT_SUMMARY_URL',
    defaultValue: 'https://www.spectrumbusiness.net/account-summary',
  });
export const getSMBYourPrivacyUrl = (): string =>
  getConfig({
    configName: 'smbPortal.YOUR_PRIVACY_URL',
    defaultValue: 'https://www.spectrum.com/policies/your-privacy-rights',
  });

export const getSMBCaliforniaPrivacyRightUrl = (): string =>
  getConfig({
    configName: 'smbPortal.CALIFORNIA_PRIVACY_RIGHT_URL',
    defaultValue: 'https://www.spectrum.com/policies/california',
  });

export const getSMBDoNotShareOptOutUrl = (): string =>
  getConfig({
    configName: 'smbPortal.DO_NOT_SELL_DATA_OPT_OUT_URL',
    defaultValue: 'https://www.spectrum.com/policies/your-privacy-rights-opt-out',
  });

export const getSMBPoliciesUrl = (): string =>
  getConfig({
    configName: 'smbPortal.POLICIES_URL',
    defaultValue: 'https://www.spectrum.com/policies/terms-of-service',
  });
export const getSMBCaliforniaConsumerSensitivePersonalInfoUrl = (): string =>
  getConfig({
    configName: 'smbPortal.CALIFORNIA_CONSUMER_SENSITIVE_PERSONAL_INFO_URL',
    defaultValue: 'https://www.spectrum.com/policies/your-privacy-rights-opt-out',
  });
export const getSMBOpenSourceLibraries = (): string =>
  getConfig({
    configName: 'smbPortal.OPEN_SOURCE_LIBRARIES',
    defaultValue: 'https://www.spectrum.net/open-source-libraries',
  });

export const getRESIChangePasswordUrl = (): string =>
  getConfig({
    configName: 'resiPortal.CHANGE_PASSWORD_URL',
    defaultValue: 'https://www.spectrumbusiness.net/user-preferences/sign-in-security',
  });

export const getRESISupportUrl = (): string =>
  getConfig({
    configName: 'resiPortal.SUPPORT_URL',
    defaultValue: 'https://www.portals.dev-spectrumbusiness.net/support',
  });

export const getRESIAccountSummaryUrl = (): string =>
  getConfig({
    configName: 'resiPortal.ACCOUNT_SUMMARY_URL',
    defaultValue: 'https://www.portals.dev-spectrumbusiness.net/account-summary',
  });

export const getRESIYourPrivacyUrl = (): string =>
  getConfig({
    configName: 'resiPortal.YOUR_PRIVACY_URL',
    defaultValue: 'https://www.spectrum.com/policies/your-privacy-rights',
  });

export const getRESICaliforniaPrivacyRightUrl = (): string =>
  getConfig({
    configName: 'resiPortal.CALIFORNIA_PRIVACY_RIGHT_URL',
    defaultValue: 'https://www.spectrum.com/policies/california',
  });

export const getRESIDoNotShareOptOutUrl = (): string =>
  getConfig({
    configName: 'resiPortal.DO_NOT_SELL_DATA_OPT_OUT_URL',
    defaultValue: 'https://www.spectrum.com/policies/your-privacy-rights-opt-out',
  });

export const getRESIServiceRateDisclosuresUrl = (): string =>
  getConfig({
    configName: 'resiPortal.SERVICE_RATE_DISCLOSURES_URL',
    defaultValue: 'https://www.spectrum.com/policies/rate-card',
  });

export const getRESIPoliciesUrl = (): string =>
  getConfig({
    configName: 'resiPortal.POLICIES_URL',
    defaultValue: 'https://www.spectrum.com/policies/terms-of-service',
  });

export const getRESICaliforniaConsumerSensitivePersonalInfoUrl = (): string =>
  getConfig({
    configName: 'resiPortal.CALIFORNIA_CONSUMER_SENSITIVE_PERSONAL_INFO_URL',
    defaultValue: 'https://www.spectrum.com/policies/your-privacy-rights-opt-out',
  });

export const getRESIOpenSourceLibraries = (): string =>
  getConfig({
    configName: 'resiPortal.OPEN_SOURCE_LIBRARIES',
    defaultValue: 'https://www.spectrum.net/open-source-libraries',
  });

export const getRESIPortalBaseUrl = (): string =>
  getConfig({
    configName: 'resiPortal.PORTAL_BASE_URL',
    defaultValue: 'https://www.spectrum.net',
  });

export const getSMBPortalBaseUrl = (): string =>
  getConfig({
    configName: 'smbPortal.PORTAL_BASE_URL',
    defaultValue: 'https://www.spectrumbusiness.net',
  });

export const getSMBSupportLinkAccount = (): string =>
  getConfig({
    configName: 'smbPortal.SUPPORT_ACCOUNT',
    defaultValue: 'https://www.spectrumbusiness.net/support/category/my-account',
  });
export const getSMBSupportLinkInternet = (): string =>
  getConfig({
    configName: 'smbPortal.SUPPORT_INTERNET',
    defaultValue: 'https://www.spectrumbusiness.net/support/category/internet',
  });
export const getSMBSupportLinkTV = (): string =>
  getConfig({
    configName: 'smbPortal.SUPPORT_TV',
    defaultValue: 'https://www.spectrumbusiness.net/support/category/tv',
  });
export const getSMBSupportLinkVoice = (): string =>
  getConfig({
    configName: 'smbPortal.SUPPORT_VOICE',
    defaultValue: 'https://www.spectrumbusiness.net/support/category/voice',
  });
export const getSMBSupportLinkAccessibility = (): string =>
  getConfig({
    configName: 'smbPortal.SUPPORT_ACCESSIBILITY',
    defaultValue: 'https://www.spectrumbusiness.net/support/general-information/accessibility',
  });

export const getRESISupportLinkAccount = (): string =>
  getConfig({
    configName: 'resiPortal.SUPPORT_ACCOUNT',
    defaultValue: 'https://www.spectrum.net/support/category/my-account',
  });
export const getRESISupportLinkInternet = (): string =>
  getConfig({
    configName: 'resiPortal.SUPPORT_INTERNET',
    defaultValue: 'https://www.spectrum.net/support/category/internet',
  });
export const getRESISupportLinkTV = (): string =>
  getConfig({
    configName: 'resiPortal.SUPPORT_TV',
    defaultValue: 'https://www.spectrum.net/support/category/tv',
  });
export const getRESISupportLinkVoice = (): string =>
  getConfig({
    configName: 'resiPortal.SUPPORT_VOICE',
    defaultValue: 'https://www.spectrum.net/support/category/voice',
  });
export const getRESISupportLinkAccessibility = (): string =>
  getConfig({
    configName: 'resiPortal.SUPPORT_ACCESSIBILITY',
    defaultValue: 'https://www.spectrum.net/page/accessibility',
  });
export const getRESISupportLinkMobile = (): string =>
  getConfig({
    configName: 'resiPortal.SUPPORT_MOBILE',
    defaultValue: 'https://www.spectrum.net/support/category/mobile',
  });

export const getRESIWatchTVLinkLiveTV = (): string =>
  getConfig({
    configName: 'resiPortal.WATCH_TV_LIVE_TV',
    defaultValue: 'https://watch.spectrum.net/livetv?sessionOverride=true',
  });
export const getRESIWatchTVLinkGuide = (): string =>
  getConfig({
    configName: 'resiPortal.WATCH_TV_GUIDE',
    defaultValue: 'https://watch.spectrum.net/guide?sessionOverride=true',
  });
export const getRESIWatchTVLinkMyLibrary = (): string =>
  getConfig({
    configName: 'resiPortal.WATCH_TV_MY_LIBRARY',
    defaultValue: 'https://watch.spectrum.net/ondemand/featured?sessionOverride=true',
  });
export const getRESIWatchTVLinkOnDemand = (): string =>
  getConfig({
    configName: 'resiPortal.WATCH_TV_ON_DEMAND',
    defaultValue: 'https://watch.spectrum.net/ondemand/?sessionOverride=true',
  });
export const getRESIWatchTVLinkDVR = (): string =>
  getConfig({
    configName: 'resiPortal.WATCH_TV_DVR',
    defaultValue: 'https://watch.spectrum.net/rdvr/my-recordings?sessionOverride=true',
  });
export const getSMBFooterLinkFindStore = (): string =>
  getConfig({
    configName: 'smbPortal.FOOTER_FIND_STORE',
    defaultValue: 'https://www.spectrumbusiness.net/support/billing/store-locator',
  });
export const getSMBFooterLinkWeatherOutage = (): string =>
  getConfig({
    configName: 'smbPortal.FOOTER_WEATHER_OUTAGE',
    defaultValue: 'https://www.spectrumbusiness.net/support/tv/general-information-about-service-outages',
  });
export const getSMBFooterLinkCustomerCommitment = (): string =>
  getConfig({
    configName: 'smbPortal.FOOTER_CUSTOMER_COMMITMENT',
    defaultValue: 'https://www.spectrum.com/business/our-customer-commitment',
  });
export const getSMBFooterLinkContactUs = (): string =>
  getConfig({
    configName: 'smbPortal.FOOTER_CONTACT_US',
    defaultValue: 'https://www.spectrumbusiness.net/contactus',
  });

export const getRESIFooterLinkFindStore = (): string =>
  getConfig({
    configName: 'resiPortal.FOOTER_FIND_STORE',
    defaultValue: 'https://www.spectrum.com/stores',
  });
export const getRESIFooterLinkWeatherOutage = (): string =>
  getConfig({
    configName: 'resiPortal.FOOTER_WEATHER_OUTAGE',
    defaultValue: 'https://www.spectrum.net/page/spectrum-storm-center',
  });
export const getRESIFooterLinkCustomerCommitment = (): string =>
  getConfig({
    configName: 'resiPortal.FOOTER_CUSTOMER_COMMITMENT',
    defaultValue: 'https://www.spectrum.com/our-customer-commitment',
  });
export const getRESIFooterLinkEnergyUsage = (): string =>
  getConfig({
    configName: 'resiPortal.FOOTER_ENERGY_USAGE',
    defaultValue: 'https://www.spectrum.net/support/general/energy-usage-your-charter-equipment',
  });
export const getRESIFooterLinkContactUs = (): string =>
  getConfig({
    configName: 'resiPortal.FOOTER_CONTACT_US',
    defaultValue: 'https://www.spectrum.net/contact-us',
  });

export const getSMBSocialMediaLinkX = (): string =>
  getConfig({
    configName: 'smbPortal.SOCIAL_MEDIA_X',
    defaultValue: 'http://x.com/spectrumbiz',
  });
export const getSMBSocialMediaLinkFacebook = (): string =>
  getConfig({
    configName: 'smbPortal.SOCIAL_MEDIA_FACEBOOK',
    defaultValue: 'http://www.facebook.com/spectrumbusiness',
  });
export const getSMBSocialMediaLinkLinkedin = (): string =>
  getConfig({
    configName: 'smbPortal.SOCIAL_MEDIA_LINKEDIN',
    defaultValue: 'https://www.linkedin.com/company/spectrum-business',
  });
export const getSMBSocialMediaLinkYoutube = (): string =>
  getConfig({
    configName: 'smbPortal.SOCIAL_MEDIA_YOUTUBE',
    defaultValue: 'http://www.youtube.com/user/CharterBusiness',
  });

export const getRESISocialMediaLinkX = (): string =>
  getConfig({
    configName: 'resiPortal.SOCIAL_MEDIA_X',
    defaultValue: 'http://x.com/getspectrum',
  });
export const getRESISocialMediaLinkFacebook = (): string =>
  getConfig({
    configName: 'resiPortal.SOCIAL_MEDIA_FACEBOOK',
    defaultValue: 'http://www.facebook.com/spectrum',
  });
export const getRESISocialMediaLinkInstagram = (): string =>
  getConfig({
    configName: 'resiPortal.SOCIAL_MEDIA_INSTAGRAM',
    defaultValue: 'http://www.instagram.com/getspectrum',
  });
export const getRESISocialMediaLinkYoutube = (): string =>
  getConfig({
    configName: 'resiPortal.SOCIAL_MEDIA_YOUTUBE',
    defaultValue: 'http://www.youtube.com/c/getspectrum',
  });

export const getPortalBaseUrl = (): string => (isSMBPortal() ? getSMBPortalBaseUrl() : getRESIPortalBaseUrl());

export interface PortalURLCollectionInterface {
  CHANGE_PASSWORD_URL: string;
  SUPPORT_URL: string;
  ACCOUNT_SUMMARY_URL: string;
  YOUR_PRIVACY_URL: string;
  CALIFORNIA_PRIVACY_RIGHT_URL: string;
  DO_NOT_SELL_DATA_OPT_OUT_URL: string;
  POLICIES_URL: string;
  CALIFORNIA_CONSUMER_SENSITIVE_PERSONAL_INFO_URL: string;
  OPEN_SOURCE_LIBRARIES: string;
  SERVICE_RATE_DISCLOSURES_URL?: string;
  SUPPORT_ACCOUNT: string;
  SUPPORT_INTERNET: string;
  SUPPORT_TV: string;
  SUPPORT_VOICE: string;
  SUPPORT_MOBILE?: string;
  SUPPORT_ACCESSIBILITY: string;
  WATCH_TV_LIVE_TV?: string;
  WATCH_TV_GUIDE?: string;
  WATCH_TV_MY_LIBRARY?: string;
  WATCH_TV_ON_DEMAND?: string;
  WATCH_TV_DVR?: string;
  FOOTER_FIND_STORE: string;
  FOOTER_WEATHER_OUTAGE: string;
  FOOTER_CUSTOMER_COMMITMENT: string;
  FOOTER_CONTACT_US: string;
  FOOTER_ENERGY_USAGE?: string;
  SOCIAL_MEDIA_X: string;
  SOCIAL_MEDIA_FACEBOOK: string;
  SOCIAL_MEDIA_LINKEDIN?: string;
  SOCIAL_MEDIA_INSTAGRAM?: string;
  SOCIAL_MEDIA_YOUTUBE: string;
}

export interface PortalURLs {
  smbPortal: PortalURLCollectionInterface;
  resiPortal: PortalURLCollectionInterface;
}

export const portalURLCollection: PortalURLs = {
  smbPortal: {
    CHANGE_PASSWORD_URL: getSMBChangePasswordUrl(),
    SUPPORT_URL: getSMBSupportUrl(),
    ACCOUNT_SUMMARY_URL: getSMBAccountSummaryUrl(),
    YOUR_PRIVACY_URL: getSMBYourPrivacyUrl(),
    CALIFORNIA_PRIVACY_RIGHT_URL: getSMBCaliforniaPrivacyRightUrl(),
    DO_NOT_SELL_DATA_OPT_OUT_URL: getSMBDoNotShareOptOutUrl(),
    POLICIES_URL: getSMBPoliciesUrl(),
    CALIFORNIA_CONSUMER_SENSITIVE_PERSONAL_INFO_URL: getSMBCaliforniaConsumerSensitivePersonalInfoUrl(),
    OPEN_SOURCE_LIBRARIES: getSMBOpenSourceLibraries(),
    SUPPORT_ACCOUNT: getSMBSupportLinkAccount(),
    SUPPORT_INTERNET: getSMBSupportLinkInternet(),
    SUPPORT_TV: getSMBSupportLinkTV(),
    SUPPORT_VOICE: getSMBSupportLinkVoice(),
    SUPPORT_ACCESSIBILITY: getSMBSupportLinkAccessibility(),
    FOOTER_FIND_STORE: getSMBFooterLinkFindStore(),
    FOOTER_WEATHER_OUTAGE: getSMBFooterLinkWeatherOutage(),
    FOOTER_CUSTOMER_COMMITMENT: getSMBFooterLinkCustomerCommitment(),
    FOOTER_CONTACT_US: getSMBFooterLinkContactUs(),
    SOCIAL_MEDIA_X: getSMBSocialMediaLinkX(),
    SOCIAL_MEDIA_FACEBOOK: getSMBSocialMediaLinkFacebook(),
    SOCIAL_MEDIA_LINKEDIN: getSMBSocialMediaLinkLinkedin(),
    SOCIAL_MEDIA_YOUTUBE: getSMBSocialMediaLinkYoutube(),
  },
  resiPortal: {
    CHANGE_PASSWORD_URL: getRESIChangePasswordUrl(),
    SUPPORT_URL: getRESISupportUrl(),
    ACCOUNT_SUMMARY_URL: getRESIAccountSummaryUrl(),
    YOUR_PRIVACY_URL: getRESIYourPrivacyUrl(),
    CALIFORNIA_PRIVACY_RIGHT_URL: getRESICaliforniaPrivacyRightUrl(),
    DO_NOT_SELL_DATA_OPT_OUT_URL: getRESIDoNotShareOptOutUrl(),
    SERVICE_RATE_DISCLOSURES_URL: getRESIServiceRateDisclosuresUrl(),
    POLICIES_URL: getRESIPoliciesUrl(),
    CALIFORNIA_CONSUMER_SENSITIVE_PERSONAL_INFO_URL: getRESICaliforniaConsumerSensitivePersonalInfoUrl(),
    OPEN_SOURCE_LIBRARIES: getRESIOpenSourceLibraries(),
    SUPPORT_ACCOUNT: getRESISupportLinkAccount(),
    SUPPORT_INTERNET: getRESISupportLinkInternet(),
    SUPPORT_TV: getRESISupportLinkTV(),
    SUPPORT_VOICE: getRESISupportLinkVoice(),
    SUPPORT_MOBILE: getRESISupportLinkMobile(),
    SUPPORT_ACCESSIBILITY: getRESISupportLinkAccessibility(),
    WATCH_TV_LIVE_TV: getRESIWatchTVLinkLiveTV(),
    WATCH_TV_GUIDE: getRESIWatchTVLinkGuide(),
    WATCH_TV_MY_LIBRARY: getRESIWatchTVLinkMyLibrary(),
    WATCH_TV_ON_DEMAND: getRESIWatchTVLinkOnDemand(),
    WATCH_TV_DVR: getRESIWatchTVLinkDVR(),
    FOOTER_FIND_STORE: getRESIFooterLinkFindStore(),
    FOOTER_WEATHER_OUTAGE: getRESIFooterLinkWeatherOutage(),
    FOOTER_CUSTOMER_COMMITMENT: getRESIFooterLinkCustomerCommitment(),
    FOOTER_CONTACT_US: getRESIFooterLinkContactUs(),
    FOOTER_ENERGY_USAGE: getRESIFooterLinkEnergyUsage(),
    SOCIAL_MEDIA_X: getRESISocialMediaLinkX(),
    SOCIAL_MEDIA_FACEBOOK: getRESISocialMediaLinkFacebook(),
    SOCIAL_MEDIA_INSTAGRAM: getRESISocialMediaLinkInstagram(),
    SOCIAL_MEDIA_YOUTUBE: getRESISocialMediaLinkYoutube(),
  },
};

export const getUrlBasedOnPortal = (key: string): string => {
  const portalUrls = isSMBPortal() ? portalURLCollection.smbPortal : portalURLCollection.resiPortal;

  return get(portalUrls, key, '');
};
